import { useCallback } from 'react';

import {
   IconSize,
   IconWrapper,
   SidePanelContentSlotLink,
   useHistoryPushWithBackAction,
   VisitPreviewIcon,
} from '@dreryk/react-components';

import { visitPaths } from '~libs.desktop.shared.paths';

import { historicalVisitTranslationKeys, visitTranslationKeys } from '../../translations';

type HistoricalVisitContentShowVisitLinkProps = {
   readonly visitId: number;
   readonly patientId: number;
   readonly disabled: boolean;
};

export const HistoricalVisitContentShowVisitLink = (props: HistoricalVisitContentShowVisitLinkProps): JSX.Element => {
   const push = useHistoryPushWithBackAction(true);
   const handleClick = useCallback(() => {
      push(
         visitPaths.getVisitHistoryPath({
            params: {
               patientId: props.patientId,
            },
            searchParams: {
               visitId: props.visitId,
            },
         }),
         {
            label: visitTranslationKeys.goBackToVisit,
         }
      );
   }, [push, props.patientId, props.visitId]);

   return (
      <SidePanelContentSlotLink
         testId={'showVisit'}
         icon={
            <IconWrapper size={IconSize.SMALL} testId={'showVisit'} disabled={props.disabled}>
               <VisitPreviewIcon />
            </IconWrapper>
         }
         onClick={handleClick}
         label={historicalVisitTranslationKeys.showVisit}
         disabled={props.disabled}
      />
   );
};
